import { CellValue } from 'react-table';
import _uniqBy from 'lodash/uniqBy';

/**
 * Aggregates columns of GapWorkStatementWorkCellValue values into a single
 * GapWorkStatementWorkCellValue value.
 */
export const aggregateStatementWork = (
    columnValues: CellValue<GapWorkStatementWorkCellValue>[],
): GapWorkStatementWorkCellValue =>
    columnValues.reduce(
        (
            acc: GapWorkStatementWorkCellValue,
            curr: GapWorkStatementWorkCellValue,
        ) => {
            if (acc.matchedWorkId === null && curr.matchedWorkId) {
                acc.matchedWorkId = curr.matchedWorkId;
            }

            if (acc.gapAudioId.length === 0 && curr.gapAudioId) {
                acc.gapAudioId = curr.gapAudioId;
            }

            if (curr.dropdownInputOptions.length > 0) {
                acc.dropdownInputOptions = _uniqBy(
                    [...acc.dropdownInputOptions, ...curr.dropdownInputOptions],
                    'id',
                );
            }

            return acc;
        },
        {
            matchedWorkId: null,
            dropdownInputOptions: [],
            gapAudioId: '',
        },
    );
